/**
 * @since 2026-04-22
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React from "react";
import { Box, LinearProgress } from "@mui/material";

const HistoryLengthPanel = ({ detail }) => {
  if (!detail) return null;
  const { years, minYears, firstDate, lastDate } = detail;
  const hasYears = typeof years === "number";
  const threshold = typeof minYears === "number" ? minYears : 10;
  const progress = hasYears ? Math.min(100, Math.max(0, (years / threshold) * 100)) : 0;
  const meetsThreshold = hasYears && years >= threshold;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 2, mb: 1 }}>
        <Box sx={{ fontSize: 22, fontWeight: 600 }}>
          {hasYears ? `${years.toFixed(2)} years` : "Insufficient data"}
        </Box>
        <Box sx={{ fontSize: 13, opacity: 0.7 }}>
          minimum required: {threshold.toFixed(1)} years
        </Box>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        color={meetsThreshold ? "success" : "error"}
        sx={{ height: 8, borderRadius: 1, mb: 2 }}
      />
      <Box sx={{ display: "flex", gap: 4, fontSize: 13 }}>
        <Box>
          <Box sx={{ opacity: 0.7 }}>First bar</Box>
          <Box>{firstDate ? firstDate.slice(0, 10) : "—"}</Box>
        </Box>
        <Box>
          <Box sx={{ opacity: 0.7 }}>Last bar</Box>
          <Box>{lastDate ? lastDate.slice(0, 10) : "—"}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HistoryLengthPanel;
